import router from '@/router'
import cmd from '@/common/Command'

const PracticeModule = {
  namespaced: true,
  state: {
    rows: [],
    chapter: [],
    answerList: [],
    content: {},
  },
  mutations: {
    setRows (state, value) {
      state.rows = value
    },
    setChapter (state, value) {
      state.chapter = value
    },
    setAnswerList (state, value) {
      state.answerList = value
    },
    setContent (state, value) {
      state.content = value
    }
  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //
    search ({ commit, state, rootState }) {

      if (state.rows.length != 0) {
        return
      }

      function callback(rows){
        var list = []
        $.each(rows, function(idx, row){
          if (row != "") {
            list.push({"id": row[0], "part" : row[1], "part_title" : row[2], "chapter": row[3], "chapter_title" : row[4], "question_count" : row[5], "time_all": row[6], "question_num": row[7], "time": row[8], "question": row[9], "answer_title": row[10], "answer": row[11], "expl": row[12]})
          }
        })
        commit('setRows', list)
      }
      cmd.getData("practice", callback)
    },
    //章ごとのページ
    showChapter ({ commit, state, rootState }, array) {
      var id = parseInt(array[0])
      var count = parseInt(array[1])
      var chapter = []
      $.each(state.rows, function(idx, row){
        if ( parseInt(row.id) >= id && parseInt(row.id) < id + count) {
          chapter.push({"id": row.id, "part": row.part, "part_title" : row.part_title, "chapter": row.chapter, "chapter_title" : row.chapter_title, "question_count" : row.question_count, "time_all": row.time_all, "question_num": row.question_num, "time": row.time})
        }
      })
      commit('setChapter', chapter)
      router.push('practiceChapter')
    },
    //次ページ
    showDetail ({ commit, state, rootState }, array) {
      var id = array[0]
      var count = array[1]
      var content = {}
      $.each(state.rows, function(idx, row){
        if (row.id == id) {
          content.id = row.id
          content.part = row.part
          content.chapter = row.chapter
          content.question_count = count
          content.question_num = row.question_num
          content.question = row.question
          content.answer_title = row.answer_title
          content.answer = row.answer
          content.expl = row.expl
          return false
        }
      })
      commit('setContent', content)
      router.push('practiceDetail', () => {})
    },
    showAnswer ({ commit, state, rootState }) {
      router.push('practiceAnswer')
    },
    showAnswerList ({ commit, state, rootState }, array) {
      var part = array[0]
      var chapter = array[1]
      var answerList = []
      $.each(state.rows, function(idx, row){
        if ( row.part == part && row.chapter == chapter ) {
          answerList.push({"id": row.id, "part": row.part, "chapter": row.chapter, "question_num": row.question_num, "answer_title": row.answer_title, "answer": row.answer, "expl": row.expl})
        }
      })
      commit('setAnswerList', answerList)
      router.push('practiceAnswerList')
    },
    returnToIndex ({ commit, state, rootState }) {
      router.push('practice')
    }

  },
  getters: {
    getRows (state, getters, rootState) {
      return state.rows
    },
    getChapter (state, getters, rootState) {
      return state.chapter
    },
    getAnswerList (state, getters, rootState) {
      return state.answerList
    },
    getContent (state, getters, rootState) {
      return state.content
    }
  }
}

export default PracticeModule



// WEBPACK FOOTER //
// ./src/store/modules/PracticeModule.js